module.exports = __webpack_public_path__ + "img/six.bb6288c1.png";